import { defineMessages } from 'react-intl';
import globalIntl from 'globalIntl'; // eslint-disable-line import/no-unresolved

const m = defineMessages({
  needPerm: {
    id: 'needPerm',
    defaultMessage: 'You need permission',
  },
  wantAccess: {
    id: 'wantAccess',
    defaultMessage: 'Want in? Ask for access admins',
  },
  reqAccess: {
    id: 'reqAccess',
    defaultMessage: 'Request Access',
  },
  youAreSignIn: {
    id: 'youAreSignIn',
    defaultMessage: 'You are signed in as',
  },
});

export default { ...globalIntl, ...m };
